const STATSIG_GOALS = {
    CART: { name: 'ecomm_cart', value: null },
    INTENT_PROCEED: { name: 'ecomm_step_continue_cta', value: 'cart' },
    CHECKOUT_LOGIN: { name: 'account_registration_login', value: null },
    CHECKOUT_DELIVERY: { name: 'ecomm_checkout', value: null },
    CHECKOUT_PAYMENT: { name: 'ecomm_payment', value: null },
    CHECKOUT_CONFIRMATION: { name: 'ecomm_completed', value: null },
    SIGNUP: { name: 'sign_up', value: null }
};

function logStatsigEvent(id) {
    if (!window.Statsig) {
        return;
    }

    if (!STATSIG_GOALS[id]) {
        return;
    }

    const event = STATSIG_GOALS[id];

    window.Statsig.StatsigClient.instance().logEvent(event.name, event.value);
}

function toggleShareBasketUrlButtonDesign() {
    if (window.Statsig) {
        const statsigInstance = window.Statsig.StatsigClient.instance();
        const experiment = statsigInstance.getExperiment('cart__share_basket_cta');
        const isShareBasketUrlButtonALink = experiment.get('isShareBasketUrlButtonALink');
        const $shareBasketButton = $('.checkout-continue .js-share-basket-url-button');

        if (isShareBasketUrlButtonALink) {
            $shareBasketButton.removeClass('share-basket-url-button').addClass('link-green text-capitalize');
        }

        $shareBasketButton.removeClass('d-none');
    }
}

function hideCheckoutProgressBar() {
    if (window.Statsig) {
        const statsigInstance = window.Statsig.StatsigClient.instance();
        const experiment = statsigInstance.getExperiment('checkout__hide_progress_bar');
        const hideProgressBarGroup = experiment.get('isNewProgressBar');
        if (hideProgressBarGroup) {
            $('.checkout-header .standard-progress-bar').hide();
        }
    }
}

module.exports = {
    handleEvent: function (event) {
        const stepGoalMap = {
            cart: 'CART',
            intentToProceed: 'DUALMODE_INTENT_PROCEED',
            signup: 'SIGNUP',
            0: 'CHECKOUT_LOGIN',
            1: 'CHECKOUT_DELIVERY',
            2: 'CHECKOUT_PAYMENT',
            4: 'CHECKOUT_CONFIRMATION',
        };

        const goal = stepGoalMap[event];
        if (goal) {
            logStatsigEvent(goal);
        }
    },
    updateStatsigUser: function (data) {
        // Update the user object
        if (window.Statsig && data && data.statsigUserID) {
            const statsigInstance = window.Statsig.StatsigClient.instance();
            const { user } = statsigInstance.getContext();
            const newUser = { ...user, userID: data.statsigUserID }
            statsigInstance.updateUserSync(newUser);

            const date = new Date();
            date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000); // 1 month
            document.cookie = 'statsig_user=' + JSON.stringify(newUser) + '; path=/; ' + cookieDomain + 'expires=' + date.toUTCString() + '; Secure; SameSite=None;';
        }
    },
    handleExperiments: function () {
        toggleShareBasketUrlButtonDesign();
        hideCheckoutProgressBar();
    }
};
